import { Fragment } from 'react';

export const C = {
  teal: '#104761', navy: '#215B97', blue: '#2774DD', head: '#DAE9F8', orange: '#E97131', peach: '#F0A983',
  yellow: '#FFFF00', gold: '#FFD700', red: '#FF3E15', dred: '#C00000', dorange: '#BD5013', title: '#F2F2F2',
  green: '#00B050',
};
const n = (v) => Math.round(Number(v || 0)).toLocaleString('en-IN');
const fs = (x) => Math.round(x * 1.45 * 10) / 10;
const td = (bg, color = '#fff', extra = {}) => ({
  background: bg, color, border: '1px solid #000', padding: '3px 6px', lineHeight: 1.3,
  whiteSpace: 'nowrap', verticalAlign: 'middle', ...extra,
});
const R = { textAlign: 'right' };
const CTR = { textAlign: 'center' };
const hit = (r) => Number(r.target || 0) > 0 && Number(r.pct || 0) >= 100;

const Progress = ({ pct, big, bg }) => {
  const w = Math.max(0, Math.min(Number(pct || 0), 100));
  return (
    <td style={td(bg || '#fff', bg ? '#fff' : '#000', {
      minWidth: 90, textAlign: big ? 'center' : 'right', fontSize: fs(big ? 11 : 8),
      backgroundImage: bg ? 'none' : `linear-gradient(to right, ${C.orange} ${w}%, #fff ${w}%)`,
    })}>{n(pct)}%</td>
  );
};

// data-nobreak: the PDF never starts a new page right after this row.
const BandHeader = ({ s, showClusters, title }) => (
  <tr data-nobreak="1">
    {showClusters
      ? <><td colSpan={2} style={td(C.blue, '#fff', { ...CTR, fontSize: fs(10), padding: '8px 6px' })}>{title || 'Clusters'}</td>
        <td colSpan={10} style={td(C.teal, '#fff', CTR)}><div>VP: {s.vp}</div>{s.head && <div>{s.head_label}: {s.head}</div>}</td></>
      : <td colSpan={12} style={td(C.teal, '#fff', CTR)}><div>VP: {s.vp}</div>{s.head && <div>{s.head_label}: {s.head}</div>}</td>}
  </tr>
);

const ColHeads = ({ first = ['Catchment', 'Clinics'], mid = ['HearClear', 'Hear.com', 'Diagnostics'], midLabel = 'MTD Revenue' }) => (
  <>
    <tr style={{ color: '#000' }} data-nobreak="1">
      {first.length === 2
        ? <><th rowSpan={2} style={td(C.head, '#000')}>{first[0]}</th><th rowSpan={2} style={td(C.head, '#000')}>{first[1]}</th></>
        : <th rowSpan={2} colSpan={2} style={td(C.head, '#000')}>{first[0]}</th>}
      <th rowSpan={2} style={td(C.head, '#000')}>Targets</th>
      <th colSpan={3} style={td(C.head, '#000')}>{midLabel}</th>
      <th colSpan={2} style={td(C.head, '#000')}>Booked</th>
      <th colSpan={2} style={td(C.head, '#000')}>Credit Note</th>
      <th rowSpan={2} style={td(C.head, '#000')}>Total</th>
      <th rowSpan={2} style={td(C.head, '#000')}>Target Progress</th>
    </tr>
    <tr data-nobreak="1">{[...mid, 'HearClear', 'Hear.com', 'HearClear', 'Hear.com'].map((h, i) => <th key={i} style={td(C.head, '#000')}>{h}</th>)}</tr>
  </>
);

const VIRTUAL_BLANK = ['rev_diag', 'bk_hcom', 'cn_hcom'];

// `g` = green fill when the row has achieved its target.
const ValueCells = ({ r, blank = [], g }) => {
  const v = (k) => (blank.includes(k) ? '' : n(r[k]));
  const c = (bg, color, extra) => td(g ? C.green : bg, g ? '#fff' : color, extra);
  return (
    <>
      <td style={c(C.orange, '#fff', R)}>{v('rev_hc')}</td>
      <td style={c(C.orange, '#fff', R)}>{v('rev_hcom')}</td>
      <td style={c(C.peach, '#fff', R)}>{v('rev_diag')}</td>
      <td style={c(C.yellow, '#000', R)}>{v('bk_hc')}</td>
      <td style={c(C.yellow, '#000', R)}>{v('bk_hcom')}</td>
      <td style={c(C.red, '#000', CTR)}>{v('cn_hc')}</td>
      <td style={c(C.red, '#000', CTR)}>{v('cn_hcom')}</td>
      <td style={c(C.orange, '#fff', R)}>{n(r.total)}</td>
    </>
  );
};

const TotalRows = ({ t, label = 'Total', blank = [] }) => (
  <>
    <tr data-nobreak="1">
      <td style={td(C.teal)} />
      <td rowSpan={2} style={td(C.teal, '#fff', { ...CTR, fontSize: fs(11) })}>{label}</td>
      <td rowSpan={2} style={td(C.teal, '#fff', R)}>{n(t.target)}</td>
      <td style={td(C.dorange, '#fff', R)}>{n(t.rev_hc)}</td>
      <td style={td(C.dorange, '#fff', R)}>{n(t.rev_hcom)}</td>
      <td style={td(C.dorange, '#fff', R)}>{blank.includes('rev_diag') ? '' : n(t.rev_diag)}</td>
      <td style={td(C.gold, '#000', R)}>{n(t.bk_hc)}</td>
      <td style={td(C.gold, '#000', R)}>{blank.includes('bk_hcom') ? '' : n(t.bk_hcom)}</td>
      <td style={td(C.dred, '#000', CTR)}>{n(t.cn_hc)}</td>
      <td style={td(C.dred, '#000', CTR)}>{blank.includes('cn_hcom') ? '' : n(t.cn_hcom)}</td>
      <td rowSpan={2} style={td(C.dorange, '#fff', { ...R, fontSize: fs(9) })}>{n(t.total)}</td>
      <Progress pct={t.pct} big />
    </tr>
    <tr>
      <td style={td(C.teal)} />
      <td colSpan={3} style={td(C.dorange, '#fff', { ...CTR, fontSize: fs(9) })}>{n(t.revenue)}</td>
      <td colSpan={2} style={td(C.gold, '#000', { ...CTR, fontSize: fs(9) })}>{n(t.booked)}</td>
      <td colSpan={2} style={td(C.dred, '#000', { ...CTR, fontSize: fs(9) })}>{n(t.cn)}</td>
      <td style={td('#fff')} />
    </tr>
  </>
);

function ClinicSection({ s, first }) {
  return (
    <>
      <BandHeader s={s} showClusters={!first && s.show_clusters !== false} />
      <ColHeads />
      {s.groups.map(g => g.rows.map((r, i) => {
        const ok = hit(r);
        return (
          <tr key={`${g.catchment}-${r.label}`} data-testid={`dcr-row-${r.label}`} data-target-hit={ok ? 'yes' : 'no'} data-nobreak={i < g.rows.length - 1 ? '1' : undefined}>
            {i === 0 && <td rowSpan={g.rows.length} style={td(g.color, '#fff', { ...CTR, fontSize: fs(g.rows.length > 1 ? 10 : 8) })}>{g.catchment}</td>}
            <td style={td(ok ? C.green : g.color, '#fff', CTR)}>{r.label}</td>
            <td style={td(ok ? C.green : g.color, '#fff', R)}>{r.target ? n(r.target) : ''}</td>
            <ValueCells r={r} g={ok} />
            <Progress pct={r.pct} bg={ok ? C.green : undefined} />
          </tr>
        );
      }))}
      <TotalRows t={s.totals} />
    </>
  );
}

function SimpleSection({ s, mid, midLabel, title, noBand }) {
  const blank = s.kind === 'virtual' ? VIRTUAL_BLANK : [];
  const m = (r) => (s.kind === 'ci' || s.kind === 'virtual' ? { ...r, rev_hc: r.cases, rev_hcom: r.revenue - r.rev_diag } : { ...r, rev_hc: r.revenue - r.rev_diag, rev_hcom: 0 });
  return (
    <>
      {!noBand && <BandHeader s={s} showClusters title={title} />}
      <ColHeads first={['HearClear Head Office']} mid={mid} midLabel={midLabel} />
      {s.rows.map(r => {
        const ok = hit(r);
        return (
          <tr key={r.label} data-testid={`dcr-row-${r.label}`} data-target-hit={ok ? 'yes' : 'no'}>
            <td colSpan={2} style={td(ok ? C.green : C.navy, '#fff', CTR)}>{r.label}</td>
            <td style={td(ok ? C.green : C.navy, '#fff', R)}>{n(r.target)}</td>
            <ValueCells r={m(r)} blank={blank} g={ok} />
            <Progress pct={r.pct} bg={ok ? C.green : undefined} />
          </tr>
        );
      })}
      <TotalRows t={{ ...m(s.totals), revenue: s.totals.revenue }} blank={blank} />
    </>
  );
}

export function RevenueSheet({ data, title }) {
  return (
    <div style={{ fontFamily: 'Arial, Helvetica, sans-serif', fontWeight: 700, fontSize: fs(7.5), background: '#fff', padding: 16, width: 1280 }}>
      <table style={{ borderCollapse: 'collapse', width: '100%' }} data-testid="dcr-sheet">
        <tbody>
          <tr data-nobreak="1"><td colSpan={12} style={td(C.title, '#000', { ...CTR, fontSize: fs(12), padding: '10px 6px' })} data-testid="dcr-title">{title}</td></tr>
          {data.sections.map((s, i) => (
            <Fragment key={s.key}>
              {s.kind === 'clinics' && <ClinicSection s={s} first={i === 0} />}
              {s.kind === 'ci' && <SimpleSection s={s} mid={['Cases', 'MTD Revenue', 'Diagnostics']} midLabel="" title="Cochlear Implants" />}
              {s.kind === 'virtual' && <SimpleSection s={s} mid={['Cases', 'MTD Revenue', 'Diagnostics']} midLabel="" title="Virtual Cluster" />}
              {s.kind === 'ho' && <SimpleSection s={s} mid={['MTD Revenue', '', 'Diagnostics']} midLabel="" noBand />}
            </Fragment>
          ))}
          <tr data-testid="dcr-mtd-total">
            <td colSpan={2} style={td(C.navy, '#fff', { ...CTR, fontSize: fs(10) })}>MTD TOTAL</td>
            <td style={td(C.navy, '#fff', { ...R, fontSize: fs(9) })}>{n(data.grand.target)}</td>
            <td colSpan={3} style={td(C.orange, '#fff', { ...CTR, fontSize: fs(10) })}>{n(data.grand.revenue)}</td>
            <td colSpan={2} style={td(C.yellow, '#000', { ...CTR, fontSize: fs(10) })}>{n(data.grand.booked)}</td>
            <td colSpan={2} style={td(C.red, '#000', { ...CTR, fontSize: fs(10) })}>{n(data.grand.cn)}</td>
            <td style={td(C.orange, '#fff', { ...R, fontSize: fs(10) })}>{n(data.grand.total)}</td>
            <Progress pct={data.grand.pct} big />
          </tr>
        </tbody>
      </table>
      <table style={{ borderCollapse: 'collapse', marginTop: 28, marginLeft: 110, fontSize: fs(9) }} data-testid="dcr-lead-summary">
        <tbody>
          <tr data-nobreak="1">{['Lead Source', 'Confirmed', 'Pendings', 'Credit Note', 'Total'].map(h => <th key={h} style={td(C.teal, '#fff', { padding: '4px 12px' })}>{h}</th>)}</tr>
          {data.lead_summary.map((r, i) => (
            <tr key={r.label} data-nobreak={i < data.lead_summary.length - 1 ? '1' : undefined}>
              <td style={td(r.label === 'Cochlear Implants' ? '#4D93D9' : C.navy, '#fff', { ...CTR, padding: '3px 12px' })}>{r.label}</td>
              <td style={td(C.orange, '#fff', R)}>{n(r.confirmed)}</td>
              <td style={td(C.yellow, '#000', R)}>{n(r.pending)}</td>
              <td style={td(C.red, '#000', CTR)}>{n(r.cn)}</td>
              <td style={td(C.orange, '#fff', R)}>{n(r.total)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
